const UserDefinitions = () => {
  return (
    <div className="bg-[#FFFAF8] top-16 z-40 -mx-4 sm:-mx-8 px-4 sm:px-8 -mt-4 sm:-mt-6 pt-4 sm:pt-6 backdrop-blur-sm  bg-slate-50">
      <div className="flex flex-col rounded-xl bg-[#FFE0C2] w-full p-2 sm:p-7 mb-1 sm:mb-10 shadow-sm">
        <p
          className={`font-satoshi font-bold text-lg sm:text-2xl text-dark mb-6`}
        >
          Definitions
        </p>
        <p className={`font-satoshi text-base text-dark mb-1`}>
          - <b>Dropper</b> - Users that have made at least 1 drop
        </p>
        <p className={`font-satoshi text-base text-dark mb-1`}>
          - <b>Regular Dropper</b> - Users that have made at least 2 drops
        </p>
        <p className={`font-satoshi text-base text-dark mb-1`}>
          - <b>Active Dropper</b> - Users that have made at least 2 drops, and
          have made a drop in the last 3 months
        </p>
        <p className={`font-satoshi text-base text-dark mb-1`}>
          - <b>Inactive Dropper</b> - Users that have made at least 2 drops, but
          have not made a drop in the last 3 months
        </p>
      </div>
    </div>
  );
};

export default UserDefinitions;
